import React from 'react'

import Modal from 'react-bootstrap/lib/Modal';
import MapAddressPickerContainer from './MapAddressPickerContainer';

const MapAddressPickerModal = (props) => {

    const {onModalHide, show} = props;

    return (
        <Modal show={show}
               onHide={onModalHide}
               animation={true}
               dialogClassName="modal-full-width modal-full-height-fix">
            <Modal.Header>
                <Modal.Title>{I18n.t('pages.locations.search.insert_address_title')}</Modal.Title>
                <button
                    className="close"
                    aria-label="Close"
                    data-dismiss="modal"
                    type="button"
                    onClick={onModalHide}
                    >
                    <i className="fal fa-times" />
                </button>
            </Modal.Header>
            <Modal.Body>
                <MapAddressPickerContainer {...props}/>
            </Modal.Body>
        </Modal>
    );
};

export default MapAddressPickerModal;
